module.exports = __webpack_public_path__ + "static/media/hero_kenia_getty_desktop.f56b5235.jpg";